import React from 'react';
import "./PointsUI.css";

function PointsUI({ points }) {
    return (
        <div className="points-ui">
            <b>Points:</b> {points}
        </div>
    )
}

export default PointsUI;
